import { jwtDecode } from "jwt-decode";

// Read the calling user's UI preferences off the JWT in sessionStorage.
// Returns an empty object when there's no token / decode fails / the
// preferences subtree doesn't exist yet. Consumers can spread the result
// and rely on `!!result.someFlag` falling back to false.
//
// Source of truth: backend POST /users/me/preferences re-signs the JWT with
// the updated user doc, so reading the decoded token here always reflects
// the user's latest saved preferences (no extra fetch required).
export function getUserPreferences() {
  try {
    const token = sessionStorage.getItem("user");
    if (!token) return {};
    return jwtDecode(token)?.preferences || {};
  } catch {
    return {};
  }
}
